/* mockup script 0 */
try{

(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rise=document.querySelectorAll('[data-rise]');
  if(reduce||!('IntersectionObserver' in window)) rise.forEach(function(e){e.classList.add('in');});
  else{var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{rootMargin:'0px 0px -8% 0px'});rise.forEach(function(e){io.observe(e);});}

  /* shop by need */
  var needs=document.getElementById('needs'),prods=document.querySelectorAll('.prod');
  needs.addEventListener('click',function(e){var b=e.target.closest('.need');if(!b)return;
    needs.querySelectorAll('.need').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
    var n=b.dataset.need;prods.forEach(function(p){var hit=n!=='all'&&p.dataset.p===n;p.classList.toggle('hit',hit);p.classList.toggle('dim',n!=='all'&&!hit);});});

  /* Hormone Harmony curves: chaos on the left / at first, harmony as the section scrolls through */
  var w1=document.getElementById('w1'),w2=document.getElementById('w2'),box=document.getElementById('scopeBox'),word=document.getElementById('scopeWord');
  var h=0,target=0,t=0;
  function path(W,H,h,t,which){var mid=H/2,amp=H*.3,d='',n=72;
    for(var i=0;i<=n;i++){var x=i/n,c=Math.max(0,1-h-x*.0);
      var local=Math.max(0,Math.min(1,c*1.25-(x*.25*h)));
      var base=Math.sin(x*Math.PI*4+t+(which?local*2.6:0));
      var noise=Math.sin(x*23+t*1.9+(which?1.3:4.1))*.46+Math.sin(x*43-t*2.6+(which?5:2))*.3+Math.sin(x*9.5+t*.7+(which?2.2:.4))*.55;
      var y=mid+amp*(base*(.5+.5*(1-local))+noise*local)+(which?1:-1)*(H*.05+local*H*.05);
      d+=(i?'L':'M')+(x*W).toFixed(1)+' '+y.toFixed(1);}
    return d;}
  function onScroll(){
    var r=box.getBoundingClientRect(),vh=innerHeight;
    target=Math.max(0,Math.min(1,(vh*.92-r.top)/(vh*.62)));
    var y=window.scrollY||document.documentElement.scrollTop;
    document.getElementById('dock').classList.toggle('on',y>520);
  }
  function frame(){
    h+=(target-h)*.06; if(reduce)h=target; else t+=.016;
    w1.setAttribute('d',path(400,170,h,t,0));w2.setAttribute('d',path(400,170,h,t,1));
    var ok=h>.8;box.classList.toggle('ok',ok);word.textContent=h<.3?NU.tx('Out of sync'):ok?NU.tx('In harmony'):NU.tx('Settling');
    if(!reduce)requestAnimationFrame(frame);
  }
  addEventListener('scroll',onScroll,{passive:true});onScroll();frame();
  if(reduce)addEventListener('scroll',frame,{passive:true});

  /* demo cart + notify */
  var n=0;document.addEventListener('click',function(e){
    var a=e.target.closest('[data-add]');if(a){e.preventDefault();n++;document.getElementById('cartN').textContent=n;return;}
    var g=e.target.closest('[data-goto]');if(g){e.preventDefault();NU.go(g.dataset.goto);return;}var z=e.target.closest('a[href="#"]');if(z)e.preventDefault();});
  document.getElementById('notifyBtn').addEventListener('click',function(){var i=document.getElementById('mail');if(i.value.indexOf('@')>0){this.textContent=NU.tx('You are on the list');i.value='';}else i.focus();});
})();

}catch(e){console.error("nu-home #0",e);}
/* mockup script 1 */
try{

(function(){
  var hero=document.getElementById('hero'),svg=document.getElementById('hw');if(!svg)return;
  var pe=svg.querySelector('.w-e'),pp=svg.querySelector('.w-p'),btn=document.getElementById('hstate'),lab=document.getElementById('hstateT');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches,t0=performance.now(),W=0,H=0,last='';
  function size(){var r=svg.getBoundingClientRect();W=r.width;H=r.height;svg.setAttribute('viewBox','0 0 '+W+' '+H);}
  function ease(x){return x<0?0:x>1?1:x*x*(3-2*x);}
  function line(t,c,ph,off){
    var d='',n=56,mid=H*(W>=900?.5:.42)+off,A=H*(W>=900?.1:.11);
    for(var i=0;i<=n;i++){var u=i/n,x=u*W;
      var calm=Math.sin(u*7.2+t*1.1+ph*.35);
      var wild=Math.sin(u*19+t*3.1+ph*2.4)*.9+Math.sin(u*31-t*4.3+ph*5)*.7+Math.sin(u*8.5+t*1.7+ph*3.3)*.8;
      var y=mid+A*((1-c)*calm+c*wild*1.7);
      d+=(i?'L':'M')+x.toFixed(1)+' '+y.toFixed(1);}
    return d;}
  function set(c){var s=c>.6?NU.tx('Out of sync'):c>.04?NU.tx('Settling…'):NU.tx('In harmony');if(s!==last){last=s;lab.textContent=s;hero.classList.toggle('calm',c<=.04);}}
  function frame(now){
    var t=(now-t0)/1000,c=reduce?0:1-ease((t-1.9)/.55);
    if(document.body.dataset.hero==='d'){if(!W)size();pe.setAttribute('d',line(t,c,0,-8*(1-c)));pp.setAttribute('d',line(t,c,1,10));set(c);}
    if(!reduce)requestAnimationFrame(frame);}
  size();addEventListener('resize',size);requestAnimationFrame(frame);
  btn.addEventListener('click',function(){t0=performance.now();});
})();

}catch(e){console.error("nu-home #1",e);}
/* mockup script 2 */
try{

(function(){
  var dock=document.getElementById('dock'),foot=document.querySelector('.foot');
  if(dock&&foot){var f=function(){dock.classList.toggle('end',foot.getBoundingClientRect().top<innerHeight-30);};addEventListener('scroll',f,{passive:true});f();}
  var form=document.getElementById('buyForm'),sub=document.getElementById('dockSub');if(!form||!sub)return;
  function pick(n,v){var r=form.querySelector('input[name="'+n+'"][value="'+v+'"]');r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}));}
  function sync(){var q=form.querySelector('input[name="qty"]:checked').value,plan=form.querySelector('input[name="plan"]:checked').value;
    dock.querySelectorAll('[data-q]').forEach(function(b){b.setAttribute('aria-pressed',b.dataset.q===q?'true':'false');});
    sub.checked=plan==='sub';
    document.getElementById('dockBtn').textContent=(plan==='sub'?NU.tx('Subscribe'):NU.tx('Add'))+' · '+document.getElementById('dockS').textContent.split('· ')[1];}
  dock.addEventListener('click',function(e){var b=e.target.closest('[data-q]');if(b)pick('qty',b.dataset.q);});
  sub.addEventListener('change',function(){pick('plan',sub.checked?'sub':'once');});
  document.getElementById('dockBtn').addEventListener('click',function(){document.getElementById('atc').click();var t=this;t.textContent=NU.tx('Added to cart');setTimeout(sync,1300);});
  form.addEventListener('change',sync);sync();
})();

}catch(e){console.error("nu-home #2",e);}
/* mockup script 3 */
try{

(function(){
  var lb=document.getElementById('lb'),im=document.getElementById('lbI'),tt=document.getElementById('lbT'),last;
  var eye='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.600-6.500 10-6.500S22 12 22 12s-3.600 6.500-10 6.500S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  document.querySelectorAll('.hh__fig,.ings__img').forEach(function(f){var g=f.querySelector('img');if(!g)return;f.classList.add('zoomable');
    var b=document.createElement('button');b.type='button';b.className='zoom';b.setAttribute('aria-label',NU.tx('View image full screen'));b.innerHTML=eye;f.appendChild(b);
    f.addEventListener('click',function(){last=b;im.src=g.src;im.alt=g.alt;var c=f.querySelector('figcaption');tt.textContent=c?c.textContent:'';lb.classList.remove('big');lb.classList.add('on');document.documentElement.style.overflow='hidden';document.getElementById('lbX').focus();});});
  function close(){lb.classList.remove('on');document.documentElement.style.overflow='';if(last)last.focus();}
  document.getElementById('lbX').addEventListener('click',close);
  lb.addEventListener('click',function(e){if(e.target===lb||e.target.id==='lbV')close();});
  im.addEventListener('click',function(){lb.classList.toggle('big');});
  addEventListener('keydown',function(e){if(e.key==='Escape'&&lb.classList.contains('on'))close();});
})();

}catch(e){console.error("nu-home #3",e);}
/* mockup script 4 */
try{

(function(){
  var d=document.getElementById('rsD');if(d&&!(window.NU&&NU.eta)){function f(n){var x=new Date();x.setDate(x.getDate()+n);return x.toLocaleDateString(NU.locale||'en',{weekday:'short',day:'numeric',month:'short'});}d.textContent=f(3)+' – '+f(7);}
  document.querySelectorAll('.rvx').forEach(function(s){var cards=[].slice.call(s.querySelectorAll('.rvx__c')),more=s.querySelector('.rvx__more'),flt='all',shown=99;
    function paint(){var hits=cards.filter(function(c){return flt==='all'||(flt==='photo'?c.dataset.photo:c.dataset.tag===flt);});
      cards.forEach(function(c){c.hidden=true;});hits.slice(0,shown).forEach(function(c){c.hidden=false;});more.hidden=hits.length<=shown;}
    s.querySelector('.rvx__f1').addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;flt=b.dataset.f;shown=99;
      this.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});paint();});
    more.addEventListener('click',function(){shown+=3;paint();});
    s.addEventListener('click',function(e){var b=e.target.closest('.rvx__h');if(b){var on=b.getAttribute('aria-pressed')!=='true';b.setAttribute('aria-pressed',on);b.textContent=on?NU.tx('Helpful ✓'):NU.tx('Helpful?');}});
    paint();});
})();

}catch(e){console.error("nu-home #4",e);}
/* mockup script 5 */
try{

(function(){
  document.querySelectorAll('.sld').forEach(function(w){var t=w.querySelector('.sld__t'),dots=w.querySelector('.sld__dots');if(!t||!dots)return;
    function vis(){return [].filter.call(t.children,function(c){return !c.hidden&&c.offsetParent!==null;});}
    function build(){var n=vis().length;dots.innerHTML='';for(var i=0;i<n;i++)dots.appendChild(document.createElement('i'));upd();}
    function idx(){var v=vis(),x=t.scrollLeft+10,k=0;v.forEach(function(c,i){if(c.offsetLeft-t.offsetLeft<=x+t.clientWidth*0.3)k=i;});return k;}
    function upd(){var k=idx();[].forEach.call(dots.children,function(d,i){d.classList.toggle('on',i===k);});}
    t.addEventListener('scroll',function(){clearTimeout(t._u);t._u=setTimeout(upd,60);},{passive:true});
    w.querySelectorAll('[data-d]').forEach(function(b){b.addEventListener('click',function(){var v=vis(),k=Math.max(0,Math.min(v.length-1,idx()+ +b.dataset.d));t.scrollTo({left:v[k].offsetLeft-t.offsetLeft-parseFloat(getComputedStyle(t).paddingLeft),behavior:'smooth'});});});
    var f=w.parentElement.querySelector('.rvx__f1');if(f)f.addEventListener('click',function(){setTimeout(function(){t.scrollTo({left:0});build();},30);});
    build();});
})();

}catch(e){console.error("nu-home #5",e);}
/* mockup script 6 */
try{

(function(){
  /* product gallery: swipe / trackpad / drag, synced with thumbnails and counter */
  var t=document.getElementById('galTrack');
  if(t){var cnt=document.getElementById('galCount'),th=document.querySelectorAll('.gal__t'),n=t.children.length;
    function cur(){return Math.round(t.scrollLeft/t.clientWidth);}
    function upd(){var k=cur();cnt.textContent=(k+1)+' / '+n;th.forEach(function(b,i){if(i===k)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});}
    t.addEventListener('scroll',function(){clearTimeout(t._u);t._u=setTimeout(upd,50);},{passive:true});
    th.forEach(function(b,i){b.addEventListener('click',function(){t.scrollTo({left:i*t.clientWidth,behavior:'smooth'});});});}
  /* mouse drag for every horizontal scroller (touch and trackpad already scroll natively) */
  var sel='.gal__track,.sld__t,.rail,.rvx__ugc,.rvx__f1,.lv-sl,.needs,.gal__rail,.lp-rc';
  document.querySelectorAll(sel).forEach(function(el){
    if(el.scrollWidth<=el.clientWidth+2&&!el.matches('.gal__track'))return;
    el.classList.add('drag-x');var down=false,sx=0,sl=0,moved=0,ldx=0,si=0;
    el.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=0;ldx=0;sx=e.clientX;sl=el.scrollLeft;si=-1;});
    window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;ldx=dx;if(Math.abs(dx)>4){moved=1;el.classList.add('drag');}el.scrollLeft=sl-dx;});
    window.addEventListener('pointerup',function(){if(!down)return;down=false;if(moved){el.classList.remove('drag');
      var kids=[].filter.call(el.children,function(c){return c.offsetParent!==null;}),best=0,bd=1e9;
      var st=0,sd=1e9;kids.forEach(function(c,i){var o=c.offsetLeft-el.offsetLeft,d=Math.abs(o-el.scrollLeft),d0=Math.abs(o-sl);if(d<bd){bd=d;best=i;}if(d0<sd){sd=d0;st=i;}});if(best===st&&Math.abs(ldx)>40)best=Math.max(0,Math.min(kids.length-1,st+(ldx<0?1:-1)));
      if(kids[best]&&getComputedStyle(el).scrollSnapType!=='none')el.scrollTo({left:kids[best].offsetLeft-el.offsetLeft-parseFloat(getComputedStyle(el).paddingLeft||0),behavior:'smooth'});}});
    el.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=0;}},true);
  });
})();

}catch(e){console.error("nu-home #6",e);}
/* mockup script 8 */
try{

(function(){
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#"]');if(!a||e.defaultPrevented)return;
    if(a.hasAttribute('data-goto')||a.hasAttribute('data-add'))return;
    var h=a.getAttribute('href');if(h==='#')return;e.preventDefault();
    var el=document.getElementById(h.slice(1));
    if(el){var top=el.getBoundingClientRect().top+scrollY-70;scrollTo({top:top,behavior:'smooth'});}
    else{NU.go('home',h.slice(1));}
  });
})();

}catch(e){console.error("nu-home #8",e);}